import React from 'react'
import TeacherVerificationList from '../components/verification/TeacherVerificationList'
import AppBar from '../components/AppBar'

function TeacherVerificationPage(props) {
    return (
        <div>
            <AppBar backTo='' displayText="Home" name="Verification List"/>
            <TeacherVerificationList identification={props.identification} />
        </div>
    )
}

export default TeacherVerificationPage